import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {getEventBuyLink} from 'modules/events/helpers';
import {MODALS} from 'modules/modals/constants';
import {showModal} from 'modules/modals/thunks';
import {useCallback, useMemo} from 'react';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

export const useEventBuyButtonConfig = () => {
    const dispatch = useAppDispatch();
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;

    const handleBuyClick = useCallback(() => {
        dispatch(showModal(MODALS.REGISTER_TO_TASTING_MODAL.name));
    }, [dispatch]);

    return useMemo(() => {
        if (!event) {
            return null;
        }

        const {eventDate, isYClients, ycActivityId, winery} = event;

        const {ycFormId, ycCompanyId} = winery;

        if (isYClients && eventDate) {
            return {
                href: getEventBuyLink(ycFormId, ycCompanyId, ycActivityId, eventDate),
                target: '_blank',
            };
        }

        return {
            onClick: handleBuyClick,
        };
    }, [event, handleBuyClick]);
};
